import React, {
  forwardRef,
  useRef,
  useImperativeHandle,
  useContext,
  useEffect,
  useState,
} from 'react';
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  TextField,
  Tooltip,
  Select,
  Chip,
  MenuItem,
  useTheme,
} from '@material-ui/core';
import { useForm } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import { useDispatch, useSelector } from 'dva';
import ErrorOutlineOutlinedIcon from '@material-ui/icons/ErrorOutlineOutlined';
import DeleteForeverOutlinedIcon from '@material-ui/icons/DeleteForeverOutlined';
import { Context } from '../../AddActivity';
import TitleML from '../TitleML/TitleML';
import StepsOneMLStyled from './StepsOneMLStyles';
import {
  TextFieldCom,
  SelectFieldCom,
  RadioFieldCom,
  CheckBoxFieldCom,
} from '../FormType';
import DateRangePickerML from '@/components/DateRangePickerML';
// import ClearIconML from '@/components/ClearIconML/index';
import NumberFormatML from '@/components/NumberFormatML';
import DataTableNativeML from '@/components/DataTableNativeML';
import ButtonTip from '@/components/buttonTip/ButtonTip';
import webStorage from '@/utils/storageManager';
import StoreModal from '@/components/StoreModalML/StoreModal';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const getStyles = (name, arr, theme) => {
  if (arr.length > 0) {
    return {
      fontWeight:
        arr.indexOf(name) === -1
          ? theme.typography.fontWeightRegular
          : theme.typography.fontWeightMedium,
      color: '#000',
    };
  }
};

const typeListRadios1 = [
  { value: '0', label: '不限制' },
  { value: '1', label: '仅会员' },
];
const typeListRadios2 = [
  { value: '0', label: '展示' },
  { value: '1', label: '隐藏' },
];
const typeListRadios3 = [
  { value: '1', label: '不限' },
  { value: '0', label: '限制' },
];
const typeListRadios4 = [
  { value: '0', label: '全部公司' },
  { value: '1', label: '指定公司' },
];
const typeListRadios5 = [
  { value: '0', label: '全部门店' },
  { value: '1', label: '指定门店' },
];
const typeListRadios6 = [
  { value: '1', label: '开启' },
  { value: '0', label: '关闭' },
];

// eslint-disable-next-line no-unused-vars
const NumberFormatCustom = React.forwardRef((props, ref) => (
  <NumberFormatML {...props} allowNegative={false} ref={ref} />
));

//计算当前分页的列表
const initDataTables = (list, page) => {
  const newList = list ?? [];
  const startPage = page > 1 ? (page - 1) * 10 : 0;
  const endPage = 10;
  const data = [...newList].splice(startPage, endPage);
  return data;
};

//计算总页数
const initPageSize = (num) => {
  return Math.ceil(num / 10);
};
export default forwardRef(
  ({ onSubmitSuccess, companyList, defaultValues, queryType = '' }, fRef) => {
    //礼品类别
    const LUCKY_TYPE = webStorage.get('DICTOBJ')?.LUCKY_TYPE;
    const LUCKY_DRAW_SELECT = LUCKY_TYPE?.map((item) => ({
      name: item.nameZh,
      value: item.dictCode,
    }));
    const { handleSubmit, control, errors, setValue, getValues, watch } =
      useForm();
    const {
      control: storeControl,
      handleSubmit: handleSubmitStore,
      setValue: setValueStore,
      getValues: getValuesStore,
      reset: resetStore,
      watch: watchStore,
    } = useForm();
    const { ref } = useContext(Context);
    const theme = useTheme();
    const dispatch = useDispatch();
    const submitRef = useRef(null);
    const [storePage, setStorePage] = useState(1);
    const [storesChooseDataId, setStoresChooseDataId] = useState([]); //可用选中的门店Id
    const [storesChooseItemData, setStoresChooseItemData] = useState([]); //可用存储所有选中数据列
    const [storesChooseItemShowData, setStoresChooseItemShowData] = useState(
      [],
    ); //可用选中的门店点确定后的值列
    const [storesChooseItemShowIdData, setStoresChooseItemShowIdData] =
      useState([]); //可用选中的门店点确定后的值Id
    const [dialogStatus, setDialogStatus] = useState(false); //选中可用门店model的状态
    const watchAllFields = watch(); //watch里不传参数监听所有
    let { storesList, storesPageSize } = useSelector(
      (state) => state.couponsSetting,
    );
    const clickInputRef = () => {
      submitRef.current.click();
    };
    useImperativeHandle(ref, () => ({
      // handleSubmit 就是暴露给父组件的方法
      clickInput: clickInputRef,
    }));
    useEffect(() => {
      for (let key in defaultValues) {
        setValue(key, defaultValues[key]);
      }
    }, [defaultValues, setValue]);

    useEffect(() => {
      if (watchAllFields.isMemberNumLimit === '1') {
        setValue('memberNumLimit', '');
      }
      if (watchAllFields.isAllCompany === '0') {
        setValue('companies', []);
      }
    }, [
      setValue,
      watchAllFields.isMemberNumLimit,
      watchAllFields.isAllCompany,
    ]);

    useEffect(() => {
      //可用
      const defaultStores = defaultValues?.stores;
      let defaultIds = []; //ids
      if (defaultStores.length > 0) {
        defaultIds = defaultStores.map((item) => item.id);
      }
      setStoresChooseDataId(defaultIds);
      setStoresChooseItemShowIdData(defaultIds);
      setStoresChooseItemData(defaultStores);
      setStoresChooseItemShowData(defaultStores);
    }, [setValue, defaultValues?.stores]);

    const columns = [
      {
        type: 'checkbox',
        width: '100',
        onChange: (a) => {
          const pageDataIds = storesList.map((item) => item.id); //当前分页的id数组
          const prevStoresChooseItemData = storesChooseItemData.filter(
            (item) => {
              //过滤掉当前页的选中列
              return pageDataIds.indexOf(item.id) === -1;
            },
          );

          let chooseDatas = storesList.filter((fItem) => {
            //当前选中的数据过滤出当前页的数据
            return a.includes(fItem.id);
          });

          const newListData = [...prevStoresChooseItemData, ...chooseDatas];
          //将选中的数据a替换老数据
          const newIdsData = newListData.map((item) => item.id);
          setStoresChooseDataId(newIdsData);
          setStoresChooseItemData(newListData);
        },
      },
      {
        title: '门店Code',
        id: 'storeNo',
        align: 'center',
        width: 150,
      },
      {
        title: '门店名称',
        id: 'name',
        align: 'center',
        width: 200,
      },
      {
        title: '门店状态',
        id: 'statusCn',
        align: 'center',
        width: 100,
      },
      {
        title: '门店类型',
        id: 'storeType',
        align: 'center',
        width: 100,
      },
    ];

    const showColumns = [
      {
        title: '门店Code',
        id: 'storeNo',
        align: 'center',
        width: 150,
      },
      {
        title: '门店名称',
        id: 'name',
        align: 'center',
        width: 460,
      },
      {
        title: '操作',
        align: 'center',
        id: 'details',
        width: 100,
        render: (items) => {
          return (
            <div
              style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                lineHeight: '64px',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  lineHeight: '64px',
                  cursor: 'pointer',
                }}
              >
                <ButtonTip title="Delete">
                  <DeleteForeverOutlinedIcon
                    style={{
                      fontSize: '20px',
                      color: queryType === 'detail' ? 'darkgray' : '#525CA3',
                    }}
                    onClick={() => {
                      queryType !== 'detail' && handleDeleteStores(items.id, 1);
                    }}
                  ></DeleteForeverOutlinedIcon>
                </ButtonTip>
              </div>
            </div>
          );
        },
      },
    ];
    // 门店的分页上一页
    const handleStorePrevious = () => {
      storePage > 1 && setStorePage(storePage - 1);
    };
    // 门店的分页下一页
    const handleStoreDown = () => {
      storesChooseItemShowData.length - storePage * 10 > 0 &&
        setStorePage(storePage + 1);
    };

    const storesAddClick = () => {
      setDialogStatus(true);
    };
    //删除选中的门店
    const handleDeleteStores = (id) => {
      const prevStoresChooseDataId = storesChooseDataId.filter((item) => {
        return item !== id;
      });
      const prevStoresChooseItemData = storesChooseItemData.filter((item) => {
        return item.id !== id;
      });
      const prevStoresChooseItemShowData = storesChooseItemShowData.filter(
        (item) => {
          return item.id !== id;
        },
      );
      const prevStoresChooseItemShowIdData = storesChooseItemShowIdData.filter(
        (item) => {
          return item !== id;
        },
      );
      setStoresChooseDataId(prevStoresChooseDataId);
      setStoresChooseItemData(prevStoresChooseItemData);
      setStoresChooseItemShowData(prevStoresChooseItemShowData);
      setStoresChooseItemShowIdData(prevStoresChooseItemShowIdData);
      setValue('stores', prevStoresChooseItemShowData);
    };
    //关闭可用选择框
    const onCloseDialog = (data) => {
      if (data) {
        setStoresChooseItemShowData(storesChooseItemData);
        setStoresChooseItemShowIdData(storesChooseDataId);
      } else {
        setStoresChooseItemData(storesChooseItemShowData);
        setStoresChooseDataId(storesChooseItemShowIdData);
      }
      setValue(
        'stores',
        getValues('isAllStore') === '1' ? storesChooseItemData : '',
      );
      setDialogStatus(false);
    };

    const changePage = (data) => {
      dispatch({
        type: 'couponsSetting/setStoresPage',
        payload: {
          value: {
            pageNum: data.pageNum,
            pageSize: data.pageSize,
          },
        },
      });
    };

    const onSubmitSuccessStore = (data) => {
      onHandleClickSearchStores(data);
    };

    const onHandleClickSearchStores = (data) => {
      dispatch({
        type: 'couponsSetting/searchStores',
        payload: {
          value: { ...data, pageNum: 1, pageSize: storesPageSize },
        },
      });
    };
    return (
      <StepsOneMLStyled>
        <Box className="step-one-wrap" ref={fRef} mr={22}>
          <form onSubmit={handleSubmit(onSubmitSuccess)}>
            <TitleML title="基础设置" fontSize="19px" p="32px 0" />
            <Box className="display-row-between" gap="0 64px">
              {/*活动名称*/}
              <Box flex="1">
                <Box sx={{ fontSize: 12, color: '#212100' }}>
                  <span style={{ color: 'red' }}>*</span>活动名称
                </Box>
                <Controller
                  render={(pr) => (
                    <TextFieldCom
                      pr={pr}
                      id="title"
                      errors={errors}
                      placeholder="请输入活动名称"
                      label="活动名称"
                      queryType={queryType}
                      setValue={setValue}
                      helperText="活动被分享后的链接标题，最长20个字符"
                      showLabel={false}
                      errorText={
                        errors?.title?.type === 'maxLength' &&
                        '文字长度超过最大限制'
                      }
                    />
                  )}
                  control={control}
                  name="title"
                  rules={{
                    required: true,
                    maxLength: 20,
                  }}
                />
              </Box>
              {/*活动时间*/}
              <Box flex="1">
                <Box sx={{ fontSize: 12, color: '#212100' }}>
                  <span style={{ color: 'red' }}>*</span>活动时间
                </Box>
                <Box>
                  <FormControl variant="standard">
                    <Controller
                      render={(rp) => (
                        <DateRangePickerML
                          label="活动时间"
                          title="活动时间"
                          startText=""
                          endText=""
                          defaultStartDate={defaultValues?.dateBeginTimestamp}
                          defaultEndDate={defaultValues?.dateEndTimestamp}
                          rp={rp}
                          setValue={setValue}
                          name="custom-form-submit-name"
                          disabled={queryType === 'detail'}
                        />
                      )}
                      name="date"
                      control={control}
                      rules={{
                        validate: () => {
                          const status = !(
                            !getValues('date') ||
                            getValues('date').startDate === null ||
                            getValues('date').endDate === null
                          );
                          return status;
                        },
                      }}
                    />
                  </FormControl>
                </Box>
                {errors.date && (
                  <Box mt={-1}>
                    <Box className="input-error-style">活动时间是必选项</Box>
                  </Box>
                )}
              </Box>
              {/*活动玩法*/}
              <Box flex="1">
                <FormControl variant="standard" sx={{ width: '100%' }}>
                  <Box sx={{ fontSize: 12, color: '#212100' }}>
                    <span style={{ color: 'red' }}>*</span>活动玩法
                  </Box>
                  <Controller
                    render={(pr) => (
                      <SelectFieldCom
                        pr={pr}
                        typeList={LUCKY_DRAW_SELECT}
                        queryType={queryType}
                      />
                    )}
                    label="活动玩法"
                    name="luckyType"
                    variant="standard"
                    control={control}
                  />
                  {/* <ClearIconML
                    handleClick={() => setValue('luckyType', 0)}
                  ></ClearIconML> */}
                </FormControl>
              </Box>
            </Box>
            <Box className="display-row-between" mt={6}>
              {/*活动详情*/}
              <Box flex="1">
                <Box sx={{ fontSize: 12, color: '#212100' }}>
                  <span style={{ color: 'red' }}>*</span>活动详情
                </Box>
                <Controller
                  render={(pr) => (
                    <TextFieldCom
                      pr={pr}
                      id="description"
                      errors={errors}
                      placeholder="请输入活动详情"
                      label="活动详情"
                      queryType={queryType}
                      helperText="活动被分享后的链接详情，最长100个字符"
                      setValue={setValue}
                      showLabel={false}
                      errorText={
                        errors?.description?.type === 'maxLength' &&
                        '文字长度超过最大限制'
                      }
                    />
                  )}
                  control={control}
                  name="description"
                  rules={{
                    required: true,
                    maxLength: 100,
                  }}
                />
              </Box>
            </Box>
            {/*限制s*/}
            <TitleML title="限制" fontSize="19px" p="56px 0 32px" />
            <Box className="display-row" gap="0 48px">
              <Box>
                <Box
                  sx={{ fontSize: 12, color: '#212100', marginBottom: '8px' }}
                >
                  <span style={{ color: 'red' }}>*</span>参与限制
                </Box>
                <Controller
                  render={(pr) => (
                    <RadioFieldCom
                      pr={pr}
                      id="isMember"
                      queryType={queryType}
                      typeList={typeListRadios1}
                    />
                  )}
                  name="isMember"
                  control={control}
                />
              </Box>
              <Box>
                <Box
                  sx={{
                    fontSize: 12,
                    color: '#212100',
                    marginBottom: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0 4px',
                  }}
                >
                  <span style={{ color: 'red' }}>*</span>参与人数
                  <Tooltip
                    placement="top"
                    title={
                      <span style={{ fontSize: 14 }}>
                        在活动页面显示已有多少人
                        <br />
                        参与，且显示人数为实际人
                        <br />
                        数与虚拟人数之和
                      </span>
                    }
                    arrow
                  >
                    <ErrorOutlineOutlinedIcon className="title-three-tip-icon" />
                  </Tooltip>
                </Box>
                <Controller
                  render={(pr) => (
                    <RadioFieldCom
                      pr={pr}
                      id="isMemberNumShow"
                      queryType={queryType}
                      typeList={typeListRadios2}
                    />
                  )}
                  name="isMemberNumShow"
                  control={control}
                />
              </Box>
              <Box>
                <Box
                  sx={{ fontSize: 12, color: '#212100', marginBottom: '8px' }}
                >
                  <span style={{ color: 'red' }}>*</span>参与人数限制
                </Box>
                <Box className="display-row">
                  <Controller
                    render={(pr) => (
                      <RadioFieldCom
                        pr={pr}
                        id="isMemberNumLimit"
                        queryType={queryType}
                        typeList={typeListRadios3}
                        lWidth="auto"
                      />
                    )}
                    name="isMemberNumLimit"
                    control={control}
                  />
                  <Box width="90px" className="number-input-algin-right">
                    <Controller
                      render={(pr) => (
                        <TextFieldCom
                          pr={pr}
                          id="memberNumLimit"
                          errors={errors}
                          label=""
                          queryType={queryType}
                          setValue={setValue}
                          isPositiveNumber={true}
                          isNumber={true}
                          isParseInt={true}
                          errorText="人数限制必填并且是不超过10位数的正整数"
                        />
                      )}
                      control={control}
                      name="memberNumLimit"
                      rules={{
                        validate: () => {
                          if (
                            (getValues('isMemberNumLimit') === '0' &&
                              // eslint-disable-next-line radix
                              !getValues('memberNumLimit')) ||
                            (getValues('memberNumLimit') &&
                              // eslint-disable-next-line radix
                              String(parseInt(getValues('memberNumLimit')))
                                .length > 10)
                          ) {
                            return false;
                          }
                          return true;
                        },
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Box>
                  <Box
                    ml={0.5}
                    fontSize="14px"
                    fontWeight="400"
                    color="#404041"
                    lineHeight="38px"
                  >
                    人参与
                  </Box>
                </Box>
              </Box>
            </Box>
            {/*限制e*/}
            <TitleML title="规则" fontSize="19px" p="56px 0 32px" />
            {/*公司规则s*/}
            <Box className="display-row" gap="0 64px" mb={3}>
              <Box>
                <Box
                  sx={{ fontSize: 12, color: '#212100', marginBottom: '8px' }}
                >
                  <span style={{ color: 'red' }}>*</span>公司规则
                </Box>
                <Box className="display-row" alignItems="center">
                  <Controller
                    render={(pr) => (
                      <RadioFieldCom
                        pr={pr}
                        id="isAllCompany"
                        queryType={queryType}
                        typeList={typeListRadios4}
                        lWidth="auto"
                      />
                    )}
                    name="isAllCompany"
                    control={control}
                  />
                  {/*指定公司的选择s*/}
                  <Box sx={{ marginTop: '-25px' }}>
                    <Controller
                      render={(pr) => (
                        <FormControl
                          sx={{ m: 1, width: 540 }}
                          variant="standard"
                          className="multiple-wrap-style"
                          disabled={
                            getValues('isAllCompany') === '0' ||
                            queryType === 'detail'
                          }
                        >
                          <InputLabel id="demo-multiple-chip-label">
                            公司名称
                          </InputLabel>
                          <Select
                            labelId="demo-multiple-chip-label"
                            id="demo-multiple-chip"
                            multiple
                            value={pr.value ?? []}
                            error={Boolean(errors.companies)}
                            onChange={(e) => {
                              return pr.onChange(e.target.value);
                            }}
                            renderValue={(selected) => {
                              return Array.isArray(selected) &&
                                selected.length > 0 ? (
                                <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                                  {selected.map((value) => (
                                    <Chip
                                      key={value}
                                      label={(() => {
                                        if (
                                          Array.isArray(companyList) &&
                                          companyList.length > 0
                                        ) {
                                          const data = companyList.find(
                                            (item) => item.id === value,
                                          );
                                          return <>{data.name}</>;
                                        }
                                      })()}
                                      sx={{ m: '2px' }}
                                    />
                                  ))}
                                </Box>
                              ) : (
                                ''
                              );
                            }}
                            MenuProps={MenuProps}
                          >
                            {Array.isArray(companyList) &&
                              companyList.length > 0 &&
                              companyList.map((data) => (
                                <MenuItem
                                  key={data.id}
                                  value={data.id}
                                  style={getStyles(
                                    data.id,
                                    getValues('companies') || [],
                                    theme,
                                  )}
                                >
                                  {data.name}
                                </MenuItem>
                              ))}
                          </Select>
                        </FormControl>
                      )}
                      control={control}
                      name="companies"
                      rules={{
                        validate: () => {
                          if (
                            getValues('isAllCompany') === '1' &&
                            getValues('companies').length === 0
                          ) {
                            return false;
                          }
                          return true;
                        },
                      }}
                    />
                  </Box>
                  {/*指定公司的选择e*/}
                </Box>
                <Box
                  className="input-error-style"
                  sx={{
                    marginLeft: '269px!important',
                    marginTop: '-11px!important',
                  }}
                >
                  {errors.companies ? '请选择公司' : ''}
                </Box>
              </Box>
            </Box>
            {/*公司规则e*/}
            {/*门店规则s*/}
            <Box className="display-row" gap="0 112px" mb={3}>
              <Box>
                <Box
                  sx={{ fontSize: 12, color: '#212100', marginBottom: '8px' }}
                >
                  <span style={{ color: 'red' }}>*</span>门店规则
                </Box>
                <Controller
                  render={(pr) => (
                    <RadioFieldCom
                      pr={pr}
                      id="isAllStore"
                      queryType={queryType}
                      typeList={typeListRadios5}
                    />
                  )}
                  name="isAllStore"
                  control={control}
                  rules={{
                    validate: () => {
                      if (
                        (getValues('isAllStore') === '1' &&
                          getValues('useStory') &&
                          storesChooseItemShowData?.length === 0) ||
                        (getValues('isAllStore') === '1' &&
                          !getValues('useStory'))
                      ) {
                        return false;
                      }
                      return true;
                    },
                  }}
                />
                <Box
                  className="input-error-style"
                  sx={{
                    marginLeft: '184px!important',
                    marginTop: '-11px!important',
                  }}
                >
                  {errors.isAllStore ? '请选择门店' : ''}
                </Box>
                {/*可用s*/}
                <Box
                  display={getValues('isAllStore') === '1' ? 'block' : 'none'}
                >
                  <Box mt={2.375} display="flex">
                    <Box className="checkbox-radio-disabled-color">
                      <Controller
                        render={(pr) => (
                          <CheckBoxFieldCom
                            pr={pr}
                            label="可用门店"
                            queryType={queryType}
                          />
                        )}
                        control={control}
                        name="useStory"
                      />
                    </Box>
                    {queryType !== 'detail' && (
                      <Button
                        disabled={getValues('isAllStore') !== '1'}
                        variant="contained"
                        className="stores-setting-button"
                        onClick={() => storesAddClick(1)}
                        title="Submit"
                      >
                        添加
                      </Button>
                    )}
                  </Box>

                  <Box width="710px" mt={3.5}>
                    <DataTableNativeML
                      pageButton={false}
                      columns={showColumns}
                      data={initDataTables(storesChooseItemShowData, storePage)}
                      columnKey="id"
                      total={100}
                      devicesMinWidth="710"
                      np={true}
                    />
                  </Box>
                </Box>
                {getValues('isAllStore') === '1' &&
                  storesChooseItemShowData?.length > 0 && (
                    <Box
                      display="flex"
                      justifyContent="flex-end"
                      gap="0 12px"
                      mt={1}
                    >
                      <Box
                        onClick={handleStorePrevious}
                        sx={{
                          cursor: 'pointer',
                          color: storePage === 1 ? '#C9C9C9' : 'inherit',
                        }}
                      >
                        上一页
                      </Box>
                      <Box>第{storePage}页</Box>
                      <Box
                        onClick={handleStoreDown}
                        sx={{
                          cursor: 'pointer',
                          color:
                            storePage * 10 >= storesChooseItemShowData?.length
                              ? '#C9C9C9'
                              : 'inherit',
                        }}
                      >
                        下一页
                      </Box>
                      <Box>
                        共{initPageSize(storesChooseItemShowData?.length || 0)}
                        页
                      </Box>
                    </Box>
                  )}
                {/*可用e*/}
              </Box>
            </Box>
            {/*门店规则e*/}
            {/*轮播获奖信息s*/}
            <Box className="display-row" gap="0 112px">
              <Box>
                <Box
                  sx={{ fontSize: 12, color: '#212100', marginBottom: '8px' }}
                >
                  <span style={{ color: 'red' }}>*</span>轮播获奖信息
                </Box>
                <Controller
                  render={(pr) => (
                    <RadioFieldCom
                      pr={pr}
                      id="isRotation"
                      queryType={queryType}
                      typeList={typeListRadios6}
                    />
                  )}
                  name="isRotation"
                  control={control}
                />
              </Box>
            </Box>
            {/*轮播获奖信息e*/}
            <Box display="none">
              <Controller
                render={() => (
                  <TextField
                    variant="standard"
                    id="outlined-multiline-static"
                    autoComplete="off"
                    label=""
                  />
                )}
                control={control}
                name="stores"
              />
            </Box>
            <Button type="submit" ref={submitRef} style={{ display: 'none' }} />
          </form>
          <StoreModal
            dialogStatus={dialogStatus}
            title="选择门店"
            chooseIds={storesChooseItemShowIdData}
            columns={columns}
            control={storeControl}
            getValues={getValuesStore}
            setValue={setValueStore}
            watch={watchStore}
            reset={resetStore}
            changePage={changePage}
            onCloseDialog={onCloseDialog}
            handleSubmit={handleSubmitStore}
            onSubmitSuccess={onSubmitSuccessStore}
          />
        </Box>
      </StepsOneMLStyled>
    );
  },
);
